// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"main_nav-m2q","main-panel":"main_nav-2hw","logo":"main_nav-1fd","simple-panel":"main_nav-2PG","container":"main_nav-2RS","panel-wrapper":"main_nav-1ii","show-mobile-menu":"main_nav-3KA","menu-wrapper":"main_nav-3e4","menu-container":"main_nav-3YE","main-nav":"main_nav-wPQ","searching":"main_nav-3Am","hide-nav":"main_nav-2tA","show-nav":"main_nav-34q"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/main_nav.module.scss
// module id = 362
// module chunks = 0